export default class CookieUtils {
  static getExpiryMidnight() {
    const date = new Date(Date.now() + (60 * 60 * 24 * 1000))
    return new Date(date.getFullYear(), date.getMonth(), date.getDate())
  }
}
